export default "__VITE_ASSET__e192468c__"